import { entryProp } from "../../../interfaces/apiCalls";
import { countries, Country } from "typed-countries";


export type addressField = 'street' | "streetNumber" | "city" | "zipCode" | "country";
export const allAddressFields : addressField[] = ["street", "streetNumber", "city", "zipCode", "country"];

export const getAddressSchema = (translate): entryProp[] => {
  return [
    // DO NOT CHANGE ORDER HERE, TEMPLATE IS ACCESSING THESE FIELDS BY THEIR INDEX !
    {
      name: "street",
      label: translate.instant('address.street'),
      type: "string",
      minLength: 1,
      required: false,
      helpMessage: translate.instant('address.street-help'),
      visible: false // evaluated in parent component only, right now !
    },
    {
      name: "streetNumber",
      label: translate.instant('address.streetNumber'),
      type: 'string',
      maxLength: 12,
      minLength: 1,
      required: false,
      helpMessage: translate.instant('address.streetNumber-help'),
      visible: false // evaluated in parent component only, right now !
    },
    {
      name: "city",
      label: translate.instant('address.city'),
      required: true,
      type: "string",
      minLength: 1,
      helpMessage: translate.instant('address.city-help'),
      visible: false, // evaluated in parent component only, right now !
      private: false // evaluated in parent component only, right now !
    },
    {
      name: "zipCode",
      label: translate.instant('address.zipCode'),
      type: "string",
      required: true,
      helpMessage: translate.instant('address.zipCode-help'),
      visible: false // evaluated in parent component only, right now !
    },
    {
      name: "country",
      label: translate.instant('address.country'),
      type: "keyValueOptions",
      options: getAndTranslateCountryNames(),
      required: true,
      helpMessage: translate.instant('address.country-help'),
      visible: false // evaluated in parent component only, right now !
    },
    {
      name: "gpsLng",
      label: 'hide me lng',
      type: "string",
      required: false,
      helpMessage: 'hide me',
      visible: false, // evaluated in parent component only, right now !
      private: true
    },
    {
      name: "gpsLat",
      label: 'hide me lat',
      type: "string",
      required: false,
      helpMessage: 'hide me',
      visible: false, // evaluated in parent component only, right now !
      private: true
    }
  ];
};

// stub for now
const getAndTranslateCountryNames = () => {

    const france: Country = (countries as unknown as Country[]).find(c => c.iso === "FR");
    const luxembourg: Country = (countries as unknown as Country[]).find(c => c.iso === "LU");
    const germany: Country = (countries as unknown as Country[]).find(c => c.iso === "DE");

    let selectedCountries : Country[] = [];
    selectedCountries.push(france);
    selectedCountries.push(luxembourg);
    selectedCountries.push(germany);

    let countryObject = {};

    selectedCountries.forEach(country => {
        countryObject[country.iso] = country.name; // TODO: Add translation
    });

    return countryObject;
}

export interface LocationAddress {
  street?: string;
  streetNumber?: string;
  city: string;
  zipCode: string;
  country: string;
  gpsLat?: number;
  gpsLng?: number;
}